export const HAS_SEEN_SERIES_PROMO_STORAGE_KEY = 'has_seen_series_promo';
export const LAST_SEEN_SERIES_PROMO_STORAGE_KEY = 'last_seen_series_promo';
